import React, { useEffect, useState } from 'react';
import { aboutData } from '../mockData';
import { railsAPI } from '../services/api';
import { Target, Users, Award, TrendingUp } from 'lucide-react';

const About = () => {
  const [stats, setStats] = useState(aboutData.stats);

  useEffect(() => {
    // Fetch real stats from API
    const fetchStats = async () => {
      try {
        const apiStats = await railsAPI.getStats();
        setStats([
          { value: `${apiStats.active_members}+`, label: 'Active Members' },
          { value: `${apiStats.projects_done}+`, label: 'Projects Done' },
          { value: `${apiStats.training_sessions}+`, label: 'Training Sessions' },
          { value: `${apiStats.tools_covered}+`, label: 'AI Tools Covered' },
          { value: `${apiStats.industry_sectors}+`, label: 'Industry Sectors' }
        ]);
      } catch (error) {
        console.error('Failed to fetch stats:', error);
        // Keep default stats from mockData
      }
    };

    fetchStats();
  }, []);

  const icons = {
    0: Users,
    1: Target,
    2: TrendingUp,
    3: Award,
    4: TrendingUp
  };

  return (
    <section id="about" className="about-section">
      <div className="about-container">
        {/* Section Header */}
        <div className="section-header">
          <h2 className="section-title">{aboutData.title}</h2>
          <p className="section-description">{aboutData.description}</p>
        </div>

        {/* Mission Statement */}
        <div className="mission-card">
          <div className="mission-icon">
            <Target size={32} />
          </div>
          <div className="mission-content">
            <h3 className="mission-title">Our Mission</h3>
            <p className="mission-text">{aboutData.mission}</p>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="stats-grid">
          {stats.map((stat, index) => {
            const Icon = icons[index];
            return (
              <div key={index} className="stat-card">
                <div className="stat-icon">
                  <Icon size={24} />
                </div>
                <div className="stat-value">{stat.value}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;
